// src/Utils/currencyHelpers.js
export const getCountryFromCurrency = (currencyCode, currencyList) => {
    if (!currencyCode || !currencyList?.length) return 'bh'; // fallback

    const currency = currencyList.find(c => c.code === currencyCode);
    if (!currency) return 'bh';

    // optional: map currency code → country manually if needed
    const currencyToCountryMap = {
        BHD: 'bh',
        USD: 'us',
        PKR: 'pk',
        INR: 'in',
        SAR: 'sa',
        AED: 'ae',
        // ...you can extend for special cases
    };

    return currencyToCountryMap[currency.code] || 'bh'; // fallback
};
